import React, { useState } from "react";
import Header from "./Header";
import ChromeBrowserSection from "./ChromeBrowserSection";
import styles from "./styles.module.scss";
import UserCaseSection from "./UserCaseSection";
import DeepActionSection from "./DeepActionSection";
import StepListSection from "./StepListSection";
import DeepSearchSection from "./DeepSearchSection";
import BrowserUseSection from "./BrowserUseSection";
import ComputerUseSection from "./ComputerUseSection";
import ControllableSection from "./ControllableSection";
import AgenticMemorySection from "./AgenticMemorySection";
import FAQ from "./FAQ";
import Footer from "./Footer";
import InfoOverlay from "./InfoOverlay";

const HomePageVariant = () => {
  // 控制下载模态框的显示状态
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  // 处理下载按钮点击事件
  const handleDownloadClick = () => {
    setIsDownloadModalOpen(true);
  };

  // 关闭模态框
  const closeModal = () => {
    setIsDownloadModalOpen(false);
  };

  return (
    <>
      <div className={styles.homePageContainer}>
        <Header onDownloadClick={handleDownloadClick} />
        <ChromeBrowserSection onDownloadClick={handleDownloadClick} />
        <UserCaseSection onDownloadClick={handleDownloadClick} />
        <DeepActionSection onDownloadClick={handleDownloadClick} />
        <StepListSection onDownloadClick={handleDownloadClick} />
        <DeepSearchSection onDownloadClick={handleDownloadClick} />
        <BrowserUseSection onDownloadClick={handleDownloadClick} />
        <ComputerUseSection onDownloadClick={handleDownloadClick} />
        <ControllableSection onDownloadClick={handleDownloadClick} />
        <AgenticMemorySection onDownloadClick={handleDownloadClick} />
        <FAQ />
        <Footer onDownloadClick={handleDownloadClick} />
      </div>

      {/* 下载确认模态框 */}
      {isDownloadModalOpen && <InfoOverlay close={closeModal} still="" fellou="" variant="download" />}
    </>
  );
};

export default HomePageVariant;
